import React from "react";
import "./LoadingSpinner.css";

export default function LoadingSpinner() {
  return (
    <div className="loader-container">
        <div className="spinner"></div>
    </div>
  );
}